import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import Title from '../../components/Title/Title';
import { fetchPublishedEvents } from '../../lib/eventsApi';
import { usePageBackground } from '../../lib/cmsUtils';
import defaultHero from '../../assets/main.svg';

import './EventsPage.scss';

export default function EventsPage() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const bgImage = usePageBackground('events', defaultHero);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      setEvents(await fetchPublishedEvents());
    } catch (err) {
      setError(err.message || 'Failed to load events');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="eventsPage">
      <Navbar />
      <header className="eventsPage__hero" style={{ backgroundImage: `url(${bgImage})` }}>
        <h1>Our Events</h1>
      </header>

      <main className="eventsPage__container">
        <Title title="Upcoming & Past Events" />

        {loading && <p className="eventsPage__status">Loading…</p>}
        {error && <p className="eventsPage__status eventsPage__status--error">{error}</p>}
        {!loading && !error && events.length === 0 && (
          <p className="eventsPage__status">No events at the moment.</p>
        )}

        <div className="eventsPage__grid">
          {events.map((ev) => (
            <article key={ev.id} className="eventsPage__card">
              {ev.image_url && (
                <div className="eventsPage__cardMedia">
                  <img src={ev.image_url} alt={ev.title} loading="lazy" />
                </div>
              )}
              <div className="eventsPage__cardBody">
                <h2>{ev.title}</h2>
                <time dateTime={ev.date}>{new Date(ev.date).toLocaleString()}</time>
                {ev.location && <p className="eventsPage__location">{ev.location}</p>}
                {ev.description && (
                  <p className="eventsPage__desc">
                    {ev.description.length > 160 ? `${ev.description.slice(0, 160)}…` : ev.description}
                  </p>
                )}
                <div className="eventsPage__cardActions">
                  <Link to={`/events/${ev.id}`}>Learn more</Link>
                  {ev.external_url && (
                    <a href={ev.external_url} target="_blank" rel="noreferrer">External link</a>
                  )}
                </div>
              </div>
            </article>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
